import { Outlet, useOutletContext, useParams } from 'react-router-dom'

export default function ApplicationConfigsLayoutPage() {
  const { application } = useOutletContext()
  const { id: applicationId } = useParams()

  return <Outlet context={{ application, applicationId }} />
}

